module.exports = __webpack_public_path__ + "static/media/sitemap_v_3_arabic.11c429f2.svg";